import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=04e1d1ac&scoped=true&"
import script from "./Reviews.vue?vue&type=script&setup=true&lang=js&"
export * from "./Reviews.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e1d1ac",
  null
  
)

export default component.exports